export const SchedulerLicenseKey = "CC-Attribution-NonCommercial-NoDerivatives";

export const MELBOURNE_TIME_ZONE = "Australia/Melbourne";

export const getClientBookingTimezone = () => {
    try {
        const timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
        if (timezone?.startsWith('Australia/')) {
            return timezone;
        }
        return MELBOURNE_TIME_ZONE;
    } catch {
        return MELBOURNE_TIME_ZONE;
    }
}

export const withUid = (fn, data, uid) => {
    data.uid = uid;
    return fn(data);
};
